/* ──────────────────────────────────────────────────────────────────────────
 * Document Vault — standalone SEBI-checklist document management console.
 *
 * ISOLATED, SEPARATE BUILD. The page chrome (topbar) lives here; the full vault
 * body is the reusable `DocumentVaultPanel`, also embedded inside the IPO
 * Navigator "Document Vault" screen. Styles scoped in `DocumentVault.css`
 * (.doc-vault-root). Tabler icons + Playfair/DM Sans loaded in public/index.html.
 * ────────────────────────────────────────────────────────────────────────── */
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import WorkspaceRefBar from "@/components/WorkspaceRefBar";
import { logJourney } from "@/lib/journey";
import "./DocumentVault.css";
import DocumentVaultPanel from "./DocumentVaultPanel";

const DocumentVault = () => {
  const navigate = useNavigate();
  useEffect(() => { logJourney("Document Vault", "Viewed", "Opened Document Vault"); }, []);

  return (
    <div className="doc-vault-root" data-testid="document-vault-page">
      {/* Minimal module chrome for back navigation */}
      <div className="dv-topbar">
        <div className="dv-brand" onClick={() => navigate("/ipo-navigator")} data-testid="dv-brand">
          IPO<span>Navigator</span>
        </div>
        <div className="dv-eyebrow">Document Vault</div>
        <div className="dv-back" onClick={() => navigate("/dashboard-new")} data-testid="dv-back">
          <i className="ti ti-arrow-left" /> Back to Dashboard
        </div>
      </div>

      <WorkspaceRefBar />
      <DocumentVaultPanel />
    </div>
  );
};

export default DocumentVault;
